var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "vx-row" }, [
    _c(
      "div",
      { staticClass: "vx-col lg:w-3/5 w-full" },
      [
        _c(
          "vx-card",
          { staticClass: "mb-4" },
          [
            _c("h4", { staticClass: "mb-1" }, [
              _vm._v(_vm._s(_vm.$t("fee_plans.plan_data"))),
            ]),
            _c("small", { staticClass: "text-muted d-block mb-3" }, [
              _vm._v(_vm._s(_vm.$t("fee_plans.plan_data_hint"))),
            ]),
            _c("div", { staticClass: "vx-row" }, [
              _c(
                "div",
                { staticClass: "vx-col sm:w-1/2 w-full" },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: _vm.$t("fee_plans.name"),
                        "label-for": "name",
                      },
                    },
                    [
                      _c("b-form-input", {
                        staticClass: "required",
                        attrs: { id: "name", type: "text" },
                        model: {
                          value: _vm.model.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.model, "name", $$v)
                          },
                          expression: "model.name",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "vx-col sm:w-1/2 w-full" },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: _vm.$t("fee_plans.description"),
                        "label-for": "description",
                      },
                    },
                    [
                      _c("b-form-input", {
                        attrs: { id: "description", type: "text" },
                        model: {
                          value: _vm.model.description,
                          callback: function ($$v) {
                            _vm.$set(_vm.model, "description", $$v)
                          },
                          expression: "model.description",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _vm.model.is_default
              ? _c(
                  "b-alert",
                  {
                    staticClass: "p-1 mb-0",
                    attrs: { show: "", variant: "info" },
                  },
                  [
                    _c("small", [
                      _vm._v(_vm._s(_vm.$t("fee_plans.default_hint"))),
                    ]),
                  ]
                )
              : _vm._e(),
          ],
          1
        ),
        _c(
          "vx-card",
          { staticClass: "mb-4" },
          [
            _c(
              "div",
              { staticClass: "flex justify-between items-center mb-4" },
              [
                _c("div", [
                  _c("h4", { staticClass: "mb-0" }, [
                    _vm._v(_vm._s(_vm.$t("fee_plans.rules"))),
                  ]),
                  _c("small", { staticClass: "text-muted" }, [
                    _vm._v(_vm._s(_vm.$t("fee_plans.rules_hint"))),
                  ]),
                ]),
                _c(
                  "b-button",
                  {
                    attrs: { variant: "flat-primary", size: "sm" },
                    on: { click: _vm.addRule },
                  },
                  [
                    _c("feather-icon", {
                      staticClass: "mr-50",
                      attrs: { icon: "PlusIcon" },
                    }),
                    _c("span", { staticClass: "align-middle" }, [
                      _vm._v(_vm._s(_vm.$t("fee_plans.add_rule"))),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._l(_vm.version.rules, function (rule, i) {
              return _c(
                "div",
                { key: i, staticClass: "rule-row border rounded p-1 mb-2" },
                [
                  _c(
                    "div",
                    { staticClass: "vx-row items-end" },
                    [
                      _c(
                        "div",
                        { staticClass: "vx-col sm:w-3/12 w-full" },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: _vm.$t("fee_plans.scope"),
                                "label-size": "sm",
                              },
                            },
                            [
                              _c("b-form-select", {
                                attrs: {
                                  options: _vm.scopeOptions,
                                  size: "sm",
                                  disabled: rule.scope_type === "BASE",
                                },
                                model: {
                                  value: rule.scope_type,
                                  callback: function ($$v) {
                                    _vm.$set(rule, "scope_type", $$v)
                                  },
                                  expression: "rule.scope_type",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      rule.scope_type === "PRODUCT_TYPE"
                        ? _c(
                            "div",
                            { staticClass: "vx-col sm:w-3/12 w-full" },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: _vm.$t("fee_plans.product_type"),
                                    "label-size": "sm",
                                  },
                                },
                                [
                                  _c("b-form-select", {
                                    attrs: {
                                      options: _vm.productTypeOptions,
                                      size: "sm",
                                    },
                                    model: {
                                      value: rule.product_type,
                                      callback: function ($$v) {
                                        _vm.$set(rule, "product_type", $$v)
                                      },
                                      expression: "rule.product_type",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : rule.scope_type === "MODALITY"
                        ? _c(
                            "div",
                            { staticClass: "vx-col sm:w-3/12 w-full" },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: _vm.$t("fee_plans.modality"),
                                    "label-size": "sm",
                                  },
                                },
                                [
                                  _c("b-form-select", {
                                    attrs: {
                                      options: _vm.modalityOptions,
                                      size: "sm",
                                    },
                                    model: {
                                      value: rule.modality_id,
                                      callback: function ($$v) {
                                        _vm.$set(rule, "modality_id", $$v)
                                      },
                                      expression: "rule.modality_id",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : rule.scope_type === "PRODUCT"
                        ? _c(
                            "div",
                            { staticClass: "vx-col sm:w-3/12 w-full" },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: _vm.$t("fee_plans.product"),
                                    "label-size": "sm",
                                  },
                                },
                                [
                                  _c("b-form-select", {
                                    attrs: {
                                      options: _vm.productOptions,
                                      size: "sm",
                                    },
                                    model: {
                                      value: rule.product_id,
                                      callback: function ($$v) {
                                        _vm.$set(rule, "product_id", $$v)
                                      },
                                      expression: "rule.product_id",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _c(
                            "div",
                            { staticClass: "vx-col sm:w-3/12 w-full" },
                            [
                              _c(
                                "small",
                                { staticClass: "text-muted d-block pb-2" },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("fee_plans.base_scope_hint"))
                                  ),
                                ]
                              ),
                            ]
                          ),
                      _c(
                        "div",
                        { staticClass: "vx-col sm:w-2/12 w-full" },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: _vm.$t("fee_plans.pricing_mode"),
                                "label-size": "sm",
                              },
                            },
                            [
                              _c("b-form-select", {
                                attrs: {
                                  options: _vm.pricingModeOptions,
                                  size: "sm",
                                },
                                model: {
                                  value: rule.pricing_mode,
                                  callback: function ($$v) {
                                    _vm.$set(rule, "pricing_mode", $$v)
                                  },
                                  expression: "rule.pricing_mode",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      rule.pricing_mode === "FLAT"
                        ? [
                            _c(
                              "div",
                              { staticClass: "vx-col sm:w-2/12 w-full" },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t("fee_plans.percent"),
                                      "label-size": "sm",
                                    },
                                  },
                                  [
                                    _c(
                                      "b-input-group",
                                      { attrs: { append: "%", size: "sm" } },
                                      [
                                        _c("b-form-input", {
                                          attrs: {
                                            type: "number",
                                            min: "0",
                                            max: "100",
                                            step: "0.01",
                                            size: "sm",
                                          },
                                          model: {
                                            value: rule.fee_percent,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                rule,
                                                "fee_percent",
                                                _vm._n($$v)
                                              )
                                            },
                                            expression: "rule.fee_percent",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "vx-col sm:w-2/12 w-full" },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: _vm.$t("fee_plans.fixed"),
                                      "label-size": "sm",
                                    },
                                  },
                                  [
                                    _c(
                                      "b-input-group",
                                      { attrs: { prepend: "R$", size: "sm" } },
                                      [
                                        _c("b-form-input", {
                                          attrs: {
                                            type: "number",
                                            min: "0",
                                            step: "0.01",
                                            size: "sm",
                                          },
                                          model: {
                                            value: rule.fee_fixed,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                rule,
                                                "fee_fixed",
                                                _vm._n($$v)
                                              )
                                            },
                                            expression: "rule.fee_fixed",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        : _vm._e(),
                      _c(
                        "div",
                        { staticClass: "vx-col sm:w-1/12 w-full pb-2 ml-auto" },
                        [
                          rule.scope_type !== "BASE"
                            ? _c("feather-icon", {
                                staticClass:
                                  "h-5 w-5 stroke-current text-danger cursor-pointer",
                                attrs: { icon: "Trash2Icon" },
                                on: {
                                  click: function ($event) {
                                    return _vm.removeRule(i)
                                  },
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                  rule.pricing_mode === "TIERED"
                    ? _c(
                        "div",
                        { staticClass: "pl-2 pt-1 border-top" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "flex justify-between items-center mb-1",
                            },
                            [
                              _c("small", { staticClass: "font-medium" }, [
                                _vm._v(_vm._s(_vm.$t("fee_plans.tiers"))),
                              ]),
                              _c(
                                "b-button",
                                {
                                  attrs: {
                                    variant: "flat-primary",
                                    size: "sm",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.addTier(rule)
                                    },
                                  },
                                },
                                [
                                  _c("feather-icon", {
                                    staticClass: "mr-50",
                                    attrs: { icon: "PlusIcon" },
                                  }),
                                  _c("span", { staticClass: "align-middle" }, [
                                    _vm._v(
                                      _vm._s(_vm.$t("fee_plans.add_tier"))
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._l(rule.tiers, function (tier, j) {
                            return _c(
                              "div",
                              { key: j, staticClass: "vx-row items-end mb-1" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "vx-col sm:w-3/12 w-full" },
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "fee_plans.tier_min_gmv"
                                          ),
                                          "label-size": "sm",
                                        },
                                      },
                                      [
                                        _c(
                                          "b-input-group",
                                          {
                                            attrs: {
                                              prepend: "R$",
                                              size: "sm",
                                            },
                                          },
                                          [
                                            _c("b-form-input", {
                                              attrs: {
                                                type: "number",
                                                min: "0",
                                                step: "0.01",
                                                size: "sm",
                                                disabled: j === 0,
                                                placeholder:
                                                  j === 0
                                                    ? _vm.$t(
                                                        "fee_plans.tier_floor"
                                                      )
                                                    : "",
                                              },
                                              model: {
                                                value: tier.min_gmv,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    tier,
                                                    "min_gmv",
                                                    _vm._n($$v)
                                                  )
                                                },
                                                expression: "tier.min_gmv",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  { staticClass: "vx-col sm:w-3/12 w-full" },
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "fee_plans.tier_min_sales"
                                          ),
                                          "label-size": "sm",
                                        },
                                      },
                                      [
                                        _c("b-form-input", {
                                          attrs: {
                                            type: "number",
                                            min: "0",
                                            size: "sm",
                                            disabled: j === 0,
                                            placeholder:
                                              j === 0
                                                ? _vm.$t("fee_plans.tier_floor")
                                                : "",
                                          },
                                          model: {
                                            value: tier.min_sales_count,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                tier,
                                                "min_sales_count",
                                                _vm._n($$v)
                                              )
                                            },
                                            expression: "tier.min_sales_count",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  { staticClass: "vx-col sm:w-2/12 w-full" },
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          label: _vm.$t("fee_plans.percent"),
                                          "label-size": "sm",
                                        },
                                      },
                                      [
                                        _c(
                                          "b-input-group",
                                          {
                                            attrs: { append: "%", size: "sm" },
                                          },
                                          [
                                            _c("b-form-input", {
                                              attrs: {
                                                type: "number",
                                                min: "0",
                                                max: "100",
                                                step: "0.01",
                                                size: "sm",
                                              },
                                              model: {
                                                value: tier.fee_percent,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    tier,
                                                    "fee_percent",
                                                    _vm._n($$v)
                                                  )
                                                },
                                                expression: "tier.fee_percent",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  { staticClass: "vx-col sm:w-2/12 w-full" },
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          label: _vm.$t("fee_plans.fixed"),
                                          "label-size": "sm",
                                        },
                                      },
                                      [
                                        _c(
                                          "b-input-group",
                                          {
                                            attrs: {
                                              prepend: "R$",
                                              size: "sm",
                                            },
                                          },
                                          [
                                            _c("b-form-input", {
                                              attrs: {
                                                type: "number",
                                                min: "0",
                                                step: "0.01",
                                                size: "sm",
                                              },
                                              model: {
                                                value: tier.fee_fixed,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    tier,
                                                    "fee_fixed",
                                                    _vm._n($$v)
                                                  )
                                                },
                                                expression: "tier.fee_fixed",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "vx-col sm:w-1/12 w-full pb-2",
                                  },
                                  [
                                    j > 0
                                      ? _c("feather-icon", {
                                          staticClass:
                                            "h-5 w-5 stroke-current text-danger cursor-pointer",
                                          attrs: { icon: "Trash2Icon" },
                                          on: {
                                            click: function ($event) {
                                              return rule.tiers.splice(j, 1)
                                            },
                                          },
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ]
                            )
                          }),
                        ],
                        2
                      )
                    : _vm._e(),
                ]
              )
            }),
          ],
          2
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "vx-col lg:w-2/5 w-full" },
      [
        _c(
          "vx-card",
          { staticClass: "mb-4" },
          [
            _c("h4", { staticClass: "mb-3" }, [
              _vm._v(_vm._s(_vm.$t("fee_plans.seller_preview"))),
            ]),
            _c("div", { staticClass: "border rounded p-1 mb-3" }, [
              _c("small", { staticClass: "font-medium d-block mb-1" }, [
                _vm._v(_vm._s(_vm.$t("fee_plans.seller_preview_hint"))),
              ]),
              _c(
                "small",
                {
                  staticClass: "text-muted",
                  staticStyle: { "white-space": "pre-line" },
                },
                [_vm._v(_vm._s(_vm.sellerPreview))]
              ),
            ]),
            _c(
              "b-alert",
              {
                staticClass: "p-1 mb-3",
                attrs: { show: "", variant: "warning" },
              },
              [
                _c(
                  "div",
                  { staticClass: "flex items-start" },
                  [
                    _c("feather-icon", {
                      staticClass: "mr-1 flex-shrink-0",
                      attrs: { icon: "GitBranchIcon" },
                    }),
                    _c("small", [
                      _vm._v(
                        _vm._s(
                          _vm.$t("fee_plans.publish_warning", {
                            version: "v" + _vm.version.version,
                          })
                        )
                      ),
                    ]),
                  ],
                  1
                ),
              ]
            ),
            _c(
              "b-form-group",
              {
                attrs: {
                  label: _vm.$t("fee_plans.effective_from"),
                  "label-size": "sm",
                },
              },
              [
                _c("b-form-input", {
                  attrs: { type: "date" },
                  model: {
                    value: _vm.publishEffectiveFrom,
                    callback: function ($$v) {
                      _vm.publishEffectiveFrom = $$v
                    },
                    expression: "publishEffectiveFrom",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "flex gap-4" },
              [
                _c(
                  "b-button",
                  {
                    staticClass: "mr-2",
                    attrs: { variant: "primary", disabled: !_vm.model.name },
                    on: { click: _vm.publish },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("fee_plans.publish")) +
                        " v" +
                        _vm._s(_vm.version.version) +
                        " "
                    ),
                  ]
                ),
                _c(
                  "b-button",
                  {
                    attrs: {
                      variant: "outline-secondary",
                      disabled: !_vm.model.name,
                    },
                    on: { click: _vm.saveDraft },
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("fee_plans.save_draft")) + " ")]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c("vx-card", [
          _c("h4", { staticClass: "mb-3" }, [
            _vm._v(_vm._s(_vm.$t("fee_plans.simulator"))),
          ]),
          _c("div", { staticClass: "vx-row" }, [
            _c(
              "div",
              { staticClass: "vx-col sm:w-1/2 w-full" },
              [
                _c(
                  "b-form-group",
                  { attrs: { label: _vm.$t("fee_plans.simulator_amount") } },
                  [
                    _c(
                      "b-input-group",
                      { attrs: { prepend: "R$" } },
                      [
                        _c("b-form-input", {
                          attrs: { type: "number", min: "0", step: "0.01" },
                          on: { change: _vm.simulate },
                          model: {
                            value: _vm.simulator.amount,
                            callback: function ($$v) {
                              _vm.$set(_vm.simulator, "amount", _vm._n($$v))
                            },
                            expression: "simulator.amount",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "vx-col sm:w-1/2 w-full" },
              [
                _c(
                  "b-form-group",
                  { attrs: { label: _vm.$t("fee_plans.product_type") } },
                  [
                    _c("b-form-select", {
                      attrs: { options: _vm.simulatorTypeOptions },
                      on: { change: _vm.simulate },
                      model: {
                        value: _vm.simulator.product_type,
                        callback: function ($$v) {
                          _vm.$set(_vm.simulator, "product_type", $$v)
                        },
                        expression: "simulator.product_type",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _c("div", { staticClass: "vx-row" }, [
            _c(
              "div",
              { staticClass: "vx-col sm:w-1/2 w-full" },
              [
                _c(
                  "b-form-group",
                  { attrs: { label: _vm.$t("fee_plans.simulator_gmv") } },
                  [
                    _c(
                      "b-input-group",
                      { attrs: { prepend: "R$" } },
                      [
                        _c("b-form-input", {
                          attrs: { type: "number", min: "0" },
                          on: { change: _vm.simulate },
                          model: {
                            value: _vm.simulator.period_gmv,
                            callback: function ($$v) {
                              _vm.$set(_vm.simulator, "period_gmv", _vm._n($$v))
                            },
                            expression: "simulator.period_gmv",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "vx-col sm:w-1/2 w-full" },
              [
                _c(
                  "b-form-group",
                  { attrs: { label: _vm.$t("fee_plans.simulator_sales") } },
                  [
                    _c("b-form-input", {
                      attrs: { type: "number", min: "0" },
                      on: { change: _vm.simulate },
                      model: {
                        value: _vm.simulator.period_sales,
                        callback: function ($$v) {
                          _vm.$set(_vm.simulator, "period_sales", _vm._n($$v))
                        },
                        expression: "simulator.period_sales",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _vm.simulator.result
            ? _c("div", { staticClass: "border-top pt-3" }, [
                _c("div", { staticClass: "flex justify-between mb-1" }, [
                  _c("small", { staticClass: "text-muted" }, [
                    _vm._v(_vm._s(_vm.$t("fee_plans.simulator_rule"))),
                  ]),
                  _c("small", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("fee_plans.scope_." + _vm.simulator.result.scope)
                      )
                    ),
                  ]),
                ]),
                _c("div", { staticClass: "flex justify-between mb-1" }, [
                  _c("small", { staticClass: "text-muted" }, [
                    _vm._v(_vm._s(_vm.$t("fee_plans.simulator_fee"))),
                  ]),
                  _c("small", { staticClass: "hb-money" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.formatCents(_vm.simulator.result.fee_amount_cents)
                        ) +
                        " (" +
                        _vm._s(_vm.simulator.result.fee_percent) +
                        "%"
                    ),
                    _vm.simulator.result.fee_fixed_cents
                      ? _c("span", [
                          _vm._v(
                            " + " +
                              _vm._s(
                                _vm.formatCents(
                                  _vm.simulator.result.fee_fixed_cents
                                )
                              )
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(") "),
                  ]),
                ]),
                _c("div", { staticClass: "flex justify-between" }, [
                  _c("small", { staticClass: "text-muted" }, [
                    _vm._v(_vm._s(_vm.$t("fee_plans.simulator_net"))),
                  ]),
                  _c("small", { staticClass: "font-medium hb-money" }, [
                    _vm._v(
                      _vm._s(
                        _vm.formatCents(_vm.simulator.result.net_amount_cents)
                      )
                    ),
                  ]),
                ]),
              ])
            : _vm._e(),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }